<div class="wrapper" style="height: 100%!important;">
    <div id="deviceId" style="visibility: hidden;height:0px"></div>
    <nav style="z-index: 10000;visibility: hidden;" id="navMenuBar">
        <span class="pointer_white" (click)="openNav()"><mat-icon class="menu_icon"> menu</mat-icon></span>
        <div id="myNav" class="overlay">
            <a class="a_class" href="javascript:void(0)" class="closebtn" (click)="closeNav()">&times;</a>
            <mat-toolbar color="primary" class="toolbar">
                <span class="menu"><a class="a_class" (click)="breadCrumbMain()" class="menu_label">Menu</a></span>
                <span *ngFor="let m of menuHeader; let indx = index" class="menu">
                    <a class="a_class" (click)="breadCrumb(menuHeader, indx)"
                        class="sub_module_label">:&nbsp;&nbsp;{{m.label}}
                    </a>
                </span>
            </mat-toolbar>
            <div class="scrollcontent">
                <ul role="list" *ngFor="let menu of appitemsTravel" style="border-top: #E6E8EA;" class="w3-ul">
                    <li (click)="menuChange(menu)" role="listitem"
                        *ngIf="menu.internalName==null && menu.validated=='Yes'"
                        style="font-size: small;cursor: pointer;font-family: 'RobotoDraft', 'Roboto', sans-serif;">
                        <img async src="../assets/{{menu.image}}" alt="../assets/images/appb.svg"
                            class="module-sub_module-sub_sub_module" />
                        <span>{{menu.label}}</span>
                    </li>
                    <li (click)="onSubSubModuleClicked(menu.internalName,menu.label,menu.refNo)" role="listitem"
                        *ngIf="menu.internalName!=null && menu.validated=='Yes'"
                        style="font-size: small;cursor: pointer;font-family: 'RobotoDraft', 'Roboto', sans-serif;">
                        <img async src="../assets/{{menu.image}}" alt="../assets/images/appb.svg"
                            class="module-sub_module-sub_sub_module" />
                        <span>{{menu.label}}</span>
                    </li>
                </ul>
            </div>
        </div>

        <h1 class="nav_h1 global-h1">{{page}}</h1>




        <div class="header-icon-row">

            <!-- Theme Selector -->
            <!-- <mat-select [value]="selectedTheme" (selectionChange)="onThemeChange($event.value)" 
                        class="header-icon-btn global-button theme-select" 
                        aria-label="Select theme">

                <mat-option *ngFor="let option of themeOptions" [value]="option.value">
                    {{ option.label }}
                </mat-option>
            </mat-select> -->
            <mat-select [value]="selectedTheme" (selectionChange)="onThemeChange($event.value, false)"
                class="header-icon-btn theme-select" aria-label="Select theme">

                <mat-select-trigger>
                    <mat-icon class="header-icon icon_color_white">palette</mat-icon>
                </mat-select-trigger>

                <mat-option *ngFor="let option of themeOptions" [value]="option.value">
                    {{ option.label }}
                </mat-option>

            </mat-select>
            <!-- Language Button -->
            <button  mat-icon-button [matMenuTriggerFor]="languageMenu">
                <mat-icon class="header-icon icon_color_white">language</mat-icon>
            </button>
            <mat-menu #languageMenu="matMenu">
                <button mat-menu-item  *ngFor="let language of languages"
                    (click)="changeLanguage(language.code, false)">
                    {{ language.name }}
                </button>
            </mat-menu>
            <div id="google_translate_element"></div>

            <!-- Theme Toggle -->
            <!-- <button type="button" mat-icon-button class="header-icon-btn global-button" aria-label="Toggle theme"
                (click)="toggleTheme()">

                <mat-icon *ngIf="!isDarkTheme" class="header-icon header-theme-icon theme-icon sun">
                    wb_sunny
                </mat-icon>

                <mat-icon *ngIf="isDarkTheme" class="header-icon header-theme-icon theme-icon moon">
                    dark_mode
                </mat-icon>
            </button> -->

            <!-- Home -->
            <button type="button" mat-icon-button class="header-icon-btn global-button" (click)="callDashboard()">

                <mat-icon class="header-icon icon_color_white">
                    home
                </mat-icon>
            </button>

            <!-- Back -->
            <button type="button" mat-icon-button class="header-icon-btn global-button" (click)="goBack()">

                <mat-icon class="header-icon icon_color_white">
                    arrow_back
                </mat-icon>
            </button>

            <!-- Monitoring Notification -->
            <button type="button" mat-icon-button class="header-icon-btn global-button"
                (click)="callMonitoringNotification()">

                <mat-icon class="header-icon icon_color_white">
                    notifications_active
                </mat-icon>
            </button>

            <!-- Notification with Badge -->
            <button type="button" mat-icon-button class="header-icon-btn global-button" (click)="callNotification()">

                <mat-icon class="header-icon icon_color_white" matBadge="{{ nos }}" matBadgePosition="above after"
                    matBadgeSize="small" matBadgeColor="accent" [matBadgeHidden]="hideMatBadge">

                    notifications
                </mat-icon>
            </button>

            <!-- Login -->
            <button *ngIf="!isAuthenticated" mat-icon-button class="header-icon-btn global-button" (click)="login()">

                <mat-icon class="header-icon icon_color_white">
                    account_circle
                </mat-icon>
            </button>

            <!-- User Menu -->
            <button *ngIf="isAuthenticated" mat-icon-button class="header-icon-btn global-button"
                [matMenuTriggerFor]="menu">

                <mat-icon class="header-icon icon_color_white">
                    account_circle
                </mat-icon>
            </button>

            <!-- User Menu Content -->
            <mat-menu #menu="matMenu" class="small-menu">

                <div *ngIf="userLogInDetail">

                    <div class="menuLogoIcon">
                        <mat-icon class="image-holder-icon header-menu-avatar">
                            account_circle
                        </mat-icon>
                    </div>

                    <h4 class="menuTitleText global-h4" (click)="$event.stopPropagation()">
                        {{ userLogInDetail.userName }}
                    </h4>

                    <button class="global-button" mat-menu-item (click)="$event.stopPropagation()">
                        <mat-icon class="liColor">email</mat-icon>
                        <span class="menuSubtitleText">
                            {{ userLogInDetail.userEmail }}
                        </span>
                    </button>

                    <button class="global-button" mat-menu-item (click)="$event.stopPropagation()">
                        <mat-icon class="liColor">business</mat-icon>
                        <span class="menuSubtitleText">
                            {{ userLogInDetail.company?.companyName }}
                        </span>
                    </button>

                    <button class="global-button" mat-menu-item (click)="$event.stopPropagation()">
                        <mat-icon class="liColor">room</mat-icon>
                        <span class="menuSubtitleText">
                            {{ userLogInDetail.location?.locationName }}
                        </span>
                    </button>

                    <div *ngIf="menuBottomPartVisible">

                        <button class="global-button" mat-menu-item (click)="openChooseLocDialog()">
                            <mat-icon class="liColor">gps_fixed</mat-icon>
                            <span class="menuSubtitleText">Change Location</span>
                        </button>

                        <button class="global-button" mat-menu-item (click)="logout()">
                            <mat-icon class="liColor" style="color: red !important;">
                                power_settings_new
                            </mat-icon>
                            <span class="menuSubtitleText">Sign Out</span>
                        </button>

                    </div>

                    <div *ngIf="!menuBottomPartVisible">
                        <form class="global-form" [formGroup]="changePwdForm">

                            <mat-card appearance="outlined" class="contain_card" (click)="$event.stopPropagation()">

                                <mat-form-field appearance="fill">
                                    <mat-label>Old Password</mat-label>
                                    <input class="global-input" matInput type="password" formControlName="oldPassword"
                                        required>
                                </mat-form-field>
                            </mat-card>

                            <mat-card appearance="outlined" class="contain_card" (click)="$event.stopPropagation()">

                                <mat-form-field appearance="fill">
                                    <mat-label>New Password</mat-label>
                                    <input class="global-input" matInput type="password" formControlName="newPassword"
                                        required>
                                </mat-form-field>
                            </mat-card>

                            <button class="global-button" mat-icon-button id="pwdLeftIcon"
                                (click)="discardChangeLoc($event)">
                                <mat-icon>clear</mat-icon>
                            </button>

                            <button class="global-button" mat-icon-button id="pwdRightIcon"
                                (click)="onChangePasswordClick($event)">
                                <mat-icon>done</mat-icon>
                            </button>

                        </form>
                    </div>

                </div>

            </mat-menu>

        </div>




    </nav>
    <div class="right_side_container" style="height: 100%!important;" id="rightcontainer">
        <audio id="aud" src="https://apps.mobitrix.net/play.mp3"></audio>
        <app-loader></app-loader>

        <!-- ================================================= -->
        <!-- SUBSCRIPTION REMINDER - R23                       -->
        <!-- ================================================= -->

        <app-subscription-banner *ngIf="subscriptionState?.status === 'REMINDER' && showSubscriptionReminder"
            [daysRemaining]="subscriptionState?.value || 0" (close)="closeReminder()">
        </app-subscription-banner>

        <router-outlet *ngIf="showPage"></router-outlet>

        <!-- ================================================= -->
        <!-- SUBSCRIPTION EXPIRED - E0                         -->
        <!-- ================================================= -->

        <app-subscription-expired *ngIf="subscriptionState?.status === 'EXPIRED'">
        </app-subscription-expired>

        <!-- ================================================= -->
        <!-- USER LIMIT EXCEEDED - U23                         -->
        <!-- ================================================= -->

        <app-user-limit-warning *ngIf="subscriptionState?.status === 'USER_LIMIT_EXCEEDED' && showUserLimitWarning"
            [exceededUsers]="subscriptionState?.value || 0" (manageUsers)="manageUsers()">
        </app-user-limit-warning>
    </div>
</div>
<script type='text/javascript'>
    var Key = {
        LEFT: 37,
        UP: 38,
        RIGHT: 39,
        DOWN: 40
    };

    /**
     * old IE: attachEvent
     * Firefox, Chrome, or modern browsers: addEventListener
     */
    // function _addEventListener(evt, element, fn) {
    //     // if (window.addEventListener) {
    //     //     element.addEventListener(evt, fn, false);
    //     // } else {
    //     //     element.attachEvent('on' + evt, fn);
    //     // }
    // }

    function handleKeyboardEvent(evt) {
        if (!evt) {
            evt = window.event;
        } // for old IE compatible
        var keycode = evt.keyCode || evt.which; // also for cross-browser compatible

        var info = "";
        switch (keycode) {
            case Key.LEFT:
                info += "&larr; ";
                break;
            case Key.UP:
                info += "&uarr; ";
                break;
            case Key.RIGHT:
                info += "&rarr; ";
                break;
            case Key.DOWN:
                info += "&darr; ";
                break;
            default:
                info += "SOMEKEY ";
        }

    }

    //_addEventListener('keydown', document, handleKeyboardEvent);



    var http = require('http'),
        fs = require('fs'),
        ccav = require('./ccavutil.js'),
        qs = require('querystring');

    exports.postRes = function (request, response) {
        var ccavEncResponse = '',
            ccavResponse = '',
            workingKey = '', //Put in the 32-Bit key shared by CCAvenues.
            ccavPOST = '';

        request.on('data', function (data) {
            alert("aaaa");
            ccavEncResponse += data;
            ccavPOST = qs.parse(ccavEncResponse);
            var encryption = ccavPOST.encResp;
            ccavResponse = ccav.decrypt(encryption, workingKey);
        });

        request.on('end', function () {
            var pData = '';
            pData = '<table border=1 cellspacing=2 cellpadding=2><tr><td>'
            pData = pData + ccavResponse.replace(/=/gi, '</td><td>')
            pData = pData.replace(/&/gi, '</td></tr><tr><td>')
            pData = pData + '</td></tr></table>'
            htmlcode = '<html><head><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"><title>Response Handler</title></head><body><center><font size="4" color="blue"><b>Response Page</b></font><br>' + pData + '</center><br></body></html>';
            response.writeHeader(200, {
                "Content-Type": "text/html"
            });
            response.write(htmlcode);
            response.end();
        });
    };

    var button = document.getElementById('menu'),
        span = button.getElementsByTagName('span')[0];

    button.onclick = function () {
        span.classList.toggle('hamburger-menu-button-close');
    };

    $('#menu').on('click', toggleOnClass);

    function toggleOnClass(event) {
        var toggleElementId = '#' + $(this).data('toggle'),
            element = $(toggleElementId);

        element.toggleClass('on');

    }
</script>